<p>
 Your selected product with id = {{proId}}
</p>

<a [routerLink] = "['/product-list']"><button>Back</button></a>